export default function Schedule() {
  const day1Events = [
    { time: '09:00', title: 'الجلسة الافتتاحية', type: 'جلسة', duration: '60 دقيقة', icon: 'ri-door-open-line' },
    { time: '10:00', title: 'تدشين منصة وثيق "مركز معلومات الشباب"', type: 'تدشين', duration: '30 دقيقة', icon: 'ri-rocket-line' },
    { time: '10:30', title: 'خريطة احتياجات الشباب في المملكة', type: 'ورقة عمل', duration: '45 دقيقة', icon: 'ri-file-text-line' },
    { time: '11:15', title: 'استراحة', type: 'استراحة', duration: '15 دقيقة', icon: 'ri-cup-line' },
    { time: '11:30', title: 'تمكين الشباب بين السياسات والواقع', type: 'ورقة عمل', duration: '45 دقيقة', icon: 'ri-file-text-line' },
    { time: '12:15', title: 'تصميم المبادرات الشبابية المبنية على الاحتياج', type: 'ورشة', duration: '90 دقيقة', icon: 'ri-tools-line' },
    { time: '13:45', title: 'صلاة الظهر وغداء', type: 'استراحة', duration: '75 دقيقة', icon: 'ri-restaurant-line' },
    { time: '15:00', title: 'أدوات قياس الأثر في البرامج الشبابية', type: 'ورشة', duration: '90 دقيقة', icon: 'ri-tools-line' },
    { time: '16:30', title: 'افتتاح المعرض الشبابي', type: 'معرض', duration: '90 دقيقة', icon: 'ri-gallery-line' }
  ];

  const day2Events = [
    { time: '09:00', title: 'دور الجمعيات الشبابية في سد فجوات الاحتياج', type: 'ورقة عمل', duration: '45 دقيقة', icon: 'ri-file-text-line' },
    { time: '09:45', title: 'الشباب وسوق العمل المستقبلي', type: 'ورقة عمل', duration: '45 دقيقة', icon: 'ri-file-text-line' },
    { time: '10:30', title: 'استراحة', type: 'استراحة', duration: '15 دقيقة', icon: 'ri-cup-line' },
    { time: '10:45', title: 'القيم والهوية الوطنية لدى الشباب', type: 'ورقة عمل', duration: '45 دقيقة', icon: 'ri-file-text-line' },
    { time: '11:30', title: 'إشراك الشباب في صناعة القرار المحلي', type: 'ورشة', duration: '90 دقيقة', icon: 'ri-tools-line' },
    { time: '13:00', title: 'صلاة الظهر وغداء', type: 'استراحة', duration: '60 دقيقة', icon: 'ri-restaurant-line' },
    { time: '14:00', title: 'الشراكات الفاعلة بين الجمعيات والقطاع الخاص', type: 'ورشة', duration: '90 دقيقة', icon: 'ri-tools-line' },
    { time: '15:30', title: 'جلسة التوصيات وصياغة المخرجات', type: 'جلسة', duration: '90 دقيقة', icon: 'ri-discuss-line' },
    { time: '17:00', title: 'الجلسة الختامية', type: 'جلسة', duration: '30 دقيقة', icon: 'ri-flag-line' }
  ];

  const getTypeColor = (type: string) => {
    switch (type) {
      case 'جلسة': return 'bg-[#1B5E20] text-white';
      case 'ورقة عمل': return 'bg-[#D4AF37] text-white';
      case 'ورشة': return 'bg-[#2E7D32] text-white';
      case 'معرض': return 'bg-purple-600 text-white';
      case 'تدشين': return 'bg-orange-600 text-white';
      case 'استراحة': return 'bg-gray-400 text-white';
      default: return 'bg-gray-600 text-white';
    }
  };

  return (
    <section id="schedule" className="py-10 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-12 md:mb-16 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B5E20] mb-3 md:mb-4">برنامج الملتقى</h2>
            <p className="text-base md:text-xl text-gray-600">جدول فعاليات يومي الملتقى</p>
          </div>
          <div className="text-right">
            <div className="text-xs md:text-sm text-gray-500">المدة الإجمالية</div>
            <div className="text-xl md:text-2xl font-bold text-[#1B5E20]">يومان كاملان</div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          <div className="space-y-4 md:space-y-6">
            <div className="bg-gradient-to-br from-[#1B5E20] to-[#2E7D32] rounded-xl md:rounded-2xl p-6 md:p-8 text-white">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold mb-2">اليوم الأول</h3>
                  <p className="text-white/80 text-sm md:text-base">15 رجب 1447هـ</p>
                  <p className="text-white/60 text-xs mt-0.5">13 يناير 2026م</p>
                </div>
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-white/20 flex items-center justify-center">
                  <i className="ri-calendar-line text-2xl md:text-3xl"></i>
                </div>
              </div>
            </div>

            <div className="space-y-3 md:space-y-4">
              {day1Events.map((event, index) => (
                <div key={index} className="relative">
                  {index < day1Events.length - 1 && (
                    <div className="hidden md:block absolute top-16 md:top-20 right-6 md:right-8 w-0.5 h-full border-r-2 border-dashed border-gray-300"></div>
                  )}
                  <div className="bg-white rounded-lg md:rounded-xl p-4 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 relative">
                    <div className="flex items-start gap-3 md:gap-4">
                      <div className="flex-shrink-0">
                        <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-[#1B5E20]/10 flex items-center justify-center relative z-10">
                          <i className={`${event.icon} text-xl md:text-2xl text-[#1B5E20]`}></i>
                        </div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-2">
                          <span className="text-lg md:text-2xl font-bold text-[#1B5E20]">{event.time}</span>
                          <span className={`px-2 md:px-3 py-1 rounded-full text-xs font-bold ${getTypeColor(event.type)}`}>
                            {event.type}
                          </span>
                        </div>
                        <h4 className="text-sm md:text-lg font-bold text-gray-800 mb-2 leading-snug">{event.title}</h4>
                        <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500">
                          <i className="ri-time-line"></i>
                          <span>{event.duration}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4 md:space-y-6">
            <div className="bg-gradient-to-br from-[#D4AF37] to-[#B8941F] rounded-xl md:rounded-2xl p-6 md:p-8 text-white">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold mb-2">اليوم الثاني</h3>
                  <p className="text-white/80 text-sm md:text-base">16 رجب 1447هـ</p>
                  <p className="text-white/60 text-xs mt-0.5">14 يناير 2026م</p>
                </div>
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-white/20 flex items-center justify-center">
                  <i className="ri-calendar-line text-2xl md:text-3xl"></i>
                </div>
              </div>
            </div>

            <div className="space-y-3 md:space-y-4">
              {day2Events.map((event, index) => (
                <div key={index} className="relative">
                  {index < day2Events.length - 1 && (
                    <div className="hidden md:block absolute top-16 md:top-20 right-6 md:right-8 w-0.5 h-full border-r-2 border-dashed border-gray-300"></div>
                  )}
                  <div className="bg-white rounded-lg md:rounded-xl p-4 md:p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 relative">
                    <div className="flex items-start gap-3 md:gap-4">
                      <div className="flex-shrink-0">
                        <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-[#D4AF37]/10 flex items-center justify-center relative z-10">
                          <i className={`${event.icon} text-xl md:text-2xl text-[#D4AF37]`}></i>
                        </div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-2">
                          <span className="text-lg md:text-2xl font-bold text-[#D4AF37]">{event.time}</span>
                          <span className={`px-2 md:px-3 py-1 rounded-full text-xs font-bold ${getTypeColor(event.type)}`}>
                            {event.type}
                          </span>
                        </div>
                        <h4 className="text-sm md:text-lg font-bold text-gray-800 mb-2 leading-snug">{event.title}</h4>
                        <div className="flex items-center gap-2 text-xs md:text-sm text-gray-500">
                          <i className="ri-time-line"></i>
                          <span>{event.duration}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 bg-gradient-to-r from-[#F5F5DC] to-[#FFF8DC] rounded-2xl md:rounded-3xl p-6 md:p-12">
          <h3 className="text-2xl md:text-3xl font-bold text-[#1B5E20] mb-6 md:mb-8 text-center">المعرض المصاحب</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center space-y-3 md:space-y-4">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl md:rounded-2xl bg-white flex items-center justify-center mx-auto shadow-lg">
                <i className="ri-community-line text-3xl md:text-4xl text-[#1B5E20]"></i>
              </div>
              <h4 className="text-lg md:text-xl font-bold text-gray-800">أجنحة الجمعيات</h4>
              <p className="text-gray-600 text-sm">عرض مبادرات وبرامج الجمعيات الشبابية</p>
            </div>
            <div className="text-center space-y-3 md:space-y-4">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl md:rounded-2xl bg-white flex items-center justify-center mx-auto shadow-lg">
                <i className="ri-lightbulb-flash-line text-3xl md:text-4xl text-[#1B5E20]"></i>
              </div>
              <h4 className="text-lg md:text-xl font-bold text-gray-800">مبادرات مبتكرة</h4>
              <p className="text-gray-600 text-sm">عرض المشاريع والأفكار الشبابية الإبداعية</p>
            </div>
            <div className="text-center space-y-3 md:space-y-4">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl md:rounded-2xl bg-white flex items-center justify-center mx-auto shadow-lg">
                <i className="ri-building-line text-3xl md:text-4xl text-[#1B5E20]"></i>
              </div>
              <h4 className="text-lg md:text-xl font-bold text-gray-800">منصات الرعاة</h4>
              <p className="text-gray-600 text-sm">التعريف بالجهات الداعمة والشريكة</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
